/** Router-level loading, error and not-found views (8.12.4 states). */
import { Button, EmptyState, ErrorState, LoadingSkeleton } from '@person-platform/ui';
import { Link, useRouter } from '@tanstack/react-router';
import { useClientTranslation } from '../i18n/i18n_setup';

export function RoutePendingView() {
  return (
    <div className="p-6">
      <LoadingSkeleton shape="tiles" rowCount={4} />
    </div>
  );
}

export function RouteErrorView() {
  const router = useRouter();
  return (
    <div className="p-6">
      <ErrorState
        onRetry={() => {
          void router.invalidate();
        }}
      />
    </div>
  );
}

export function RouteNotFoundView() {
  const { t: translate } = useClientTranslation();
  return (
    <div className="p-6">
      <EmptyState
        title={translate('errors.not_found_title')}
        description={translate('errors.not_found_text')}
        action={
          <Button asChild variant="primary" size="sm">
            <Link to="/">{translate('errors.go_home')}</Link>
          </Button>
        }
      />
    </div>
  );
}
